import { DiagnosisEventNote } from "./diagnosis-event-note";
import { FilterSelectItem } from "./filter-select-item";
import { PayerItem } from "./payer-item";
import { SimpleUserOption } from "./simple-user-option";

export class DiagnosisEventItem {
    Checked?: boolean;
    ID?: number;
    EventTypeID?: number;
    EventTypeName?: string;
    DateOfService?: string;
    ServiceLocation?: string;
    VisitID?: string;
    EMRPID?: string;
    ICDCODE?: string;
    StatusState?: FilterSelectItem;
    Status?: FilterSelectItem;
    RootCause?: FilterSelectItem;
    RootCauseReason?: string;
    PreferredAction?: FilterSelectItem;
    Payer?: PayerItem;
    AssignedTo?: SimpleUserOption;
    Notes?: DiagnosisEventNote[];
    SuperbillStatus?: string;
    HCCCode?: string;
    BillingChargePostingDate?: string;
    BillingPaymentPostingDate?: string;
    EMRDocumentVersion?: string;
    EMRDocumentVersionCreateDate?: string;
    EMRDocumentSignedDate?: string;
    PatientFirstName?: string;
    PatientLastName?: string;
    PatientDateOfBirth?: string;
    PaymentYear?: number;
    IsOnSupplementalFeed?: boolean;
    ASMRecordType?: 'A' | 'D' | null;
    EnableEditASMType?: boolean;
    IsDocumentInEMR?: boolean;
    LastModifiedDateTime?: string;
    LastModifiedBy?: SimpleUserOption;
    CreatedDateTime?: string;
    CCN?: string;
    PatientMiddleName?: string;
    PatientSuffix?: string;
    PatientAddress1?: string;
    PatientAddress2?: string;
    PatientAddressCity?: string;
    PatientAddressState?: string;
    PatientAddressCode?: string;
    PatientGender?: string;
    PatientPCPFirstName?: string;
    PatientPCPLastName?: string;
    RenderingProviderFirstName?: string;
    RenderingProviderLastName?: string;
    RenderingProviderNPI?: string;
    RenderingProviderTaxID?: string;
    RenderingProviderTaxonomyCode?: string;
    RiskAdjustableCPT?: string;
    PlaceOfService?: string;
    RCMPID?: string;
    BillableProviderNPI?: string;
    BillableProviderName?: string;
    PatientDeceasedDate?: string;
    MBI?: string;
    PatientPolicyID?: string;
    TargetedHCC?: number;
    IcdOnClaim?: string;
    HasChildRecords?: boolean;
    PatientOnMAO?: boolean | null;
    DxOnMAO?: boolean | null;
    MAOStatus?: string | null;
    CurrentDate?: string;
    ClaimID?: number | null;
    FacilityName?: string | null;
    ClaimNumber?: string | null;
    ClaimType?: string | null;
    TOBCode?: string | null;
    RevenueCode?: string | null;
    PayerSubmissionDeadline?: string | null;
    DaysInStatus?: string | null;
    MAOCount?: number | null;
}
